import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { AppRole } from "@shop-ledger/shared-types";
import { useAuth } from "../auth/AuthContext";

export interface RequireRoleProps {
  roles: readonly AppRole[];
  children: ReactNode;
}

/**
 * Client-side route guard — same pattern and same caveat as `pos-pwa/src/roles/RequireRole.tsx`:
 * this hides/denies a route for UX only. The backend's `require_roles(...)` dependencies
 * and RLS are the real boundary (§10's design note).
 */
export function RequireRole({ roles, children }: RequireRoleProps) {
  const { status, user } = useAuth();

  if (status !== "authenticated" || !user) {
    return <Navigate to="/login" replace />;
  }
  if (!roles.includes(user.role)) {
    return <Navigate to="/not-authorized" replace />;
  }
  return <>{children}</>;
}
